import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const [selectedState, setSelectedState] = useState('California');
  const { addToCart } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, selectedState);
    toast.success('Added to bag', { description: `${product.name} — ${selectedState}` });
  };

  return (
    <div className="product-card group" data-testid={`product-card-${product.slug}`}>
      <Link to={`/products/${product.slug}`} className="block">
        <div className="aspect-square overflow-hidden bg-bb-black">
          <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        </div>
      </Link>
      <div className="p-6 text-center">
        <span className="t-label c-gold text-[10px] block mb-3">{product.category}</span>
        <Link to={`/products/${product.slug}`}>
          <h3 className="font-heading text-xl c-cream mb-2 tracking-wide hover:c-gold transition-colors">{product.name}</h3>
        </Link>
        <p className="font-heading text-lg c-muted mb-5">${product.price.toFixed(2)}</p>
        <div className="flex items-center justify-center gap-5 mb-5">
          {product.state_options.map((s) => (
            <button
              key={s}
              onClick={(e) => { e.preventDefault(); setSelectedState(s); }}
              className={`flex items-center gap-2 t-label text-[10px] transition-all ${selectedState === s ? 'c-cream' : 'c-muted hover:c-cream'}`}
              data-testid={`state-${s.toLowerCase()}-${product.slug}`}
            >
              <span className={s === 'California' ? 'dot-ca' : 'dot-az'} />
              {s}
            </button>
          ))}
        </div>
        <button onClick={handleAdd} className="btn-primary w-full text-[10px]" data-testid={`add-to-cart-${product.slug}`}>
          Add to Bag
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
